export const FETCH_SERVICE_LIST = {
  init: 'services/FETCH_SERVICE_LIST/init',
  request: 'services/FETCH_SERVICE_LIST/request',
  success: 'services/FETCH_SERVICE_LIST/success',
  failure: 'services/FETCH_SERVICE_LIST/failure',
  cancel: 'services/FETCH_SERVICE_LIST/cancel',
} as const;

export const FETCH_SERVICE_PRICE_LIST = {
  init: 'services/FETCH_SERVICE_PRICE_LIST/init',
  request: 'services/FETCH_SERVICE_PRICE_LIST/request',
  success: 'services/FETCH_SERVICE_PRICE_LIST/success',
  failure: 'services/FETCH_SERVICE_PRICE_LIST/failure',
} as const;

export const SERVICES_STORE_NAME = 'services' as const;
